module.exports = __webpack_public_path__ + "static/media/key.b1a645b7.png";